import Image from 'next/image';
import { eePromoImpHandler, setPromoDetailsCookie } from '@utils/gtm';
import { GridIcon } from '@adapters/prismic/types/slices';
import { useEffect, useMemo, useRef } from 'react';
import useObjectVisibility from '@hooks/useObjectVisibility';
import { useLocale } from '@hooks/useLocale';
import styles from './IconGrid.module.scss';

// We aren't breaking these rules as its just analytics not functionality
// The errors only throw because href has been moved to Link parent component
/* tslint:disable:jsx-a11y/click-events-have-key-events jsx-a11y/no-static-element-interactions */

export interface IconGridItemProps {
  image: GridIcon['image'];
  link: GridIcon['link'];
  trackPromos?: boolean;
  positionWithinSlice: number;
  pageType?: string;
  sliceIndex: number;
}

const IconGridItem = ({
  image,
  link,
  trackPromos,
  pageType,
  positionWithinSlice,
  sliceIndex,
}: IconGridItemProps) => {
  const ref = useRef<any>(null);
  const isVisible = useObjectVisibility(ref);
  const locale = useLocale();
  const promoDetails = useMemo(
    () => ({
      id: image.alt,
      name: image.alt,
      type: 'image',
      url: link,
      position: `${pageType}-${sliceIndex}-IconGrid-${positionWithinSlice}`,
    }),
    [image.alt, link, pageType, positionWithinSlice, sliceIndex]
  );

  useEffect(() => {
    if (trackPromos && isVisible) {
      eePromoImpHandler(promoDetails);
    }
  }, [isVisible, promoDetails, trackPromos]);

  return (
    <div className={styles.iconGridItemWrapper}>
      <div className={styles.iconGridItem} key={`icon-grid-${image.url}`}>
        {link ? (
          <a
            href={`/${locale}${link}`}
            onClick={
              trackPromos
                ? () => setPromoDetailsCookie(promoDetails)
                : undefined
            }
          >
            <Image
              src={image.url}
              alt={image.alt}
              quality={65}
              fill
              sizes="(min-width: 720px) 384px, 256px"
            />
          </a>
        ) : (
          <Image
            src={image.url}
            alt={image.alt}
            quality={65}
            fill
            sizes="(min-width: 720px) 384px, 256px"
          />
        )}
      </div>
    </div>
  );
};

export default IconGridItem;
